import React from 'react';

import { a } from '@react-spring/web';
import arrow from 'assets/images/icons/arrowRight.png';
import { Button } from 'components/Atoms';

import * as T from './interfaces';
import * as S from './styles';

export const ExpandInfo = React.memo<T.IExpandInfoProps>(
  ({
    children,
    isOpen,
    title,
    id,
    description,
    logEvent,
    contentStyle,
    verticalInteraction,
    containerChildRef,
    handleExpand,
  }) => (
    <S.Wrapper id={id} data-testid={id} isOpen={isOpen}>
      <S.Content style={contentStyle}>
        <a.div ref={containerChildRef} style={verticalInteraction}>
          {children}
        </a.div>
      </S.Content>
      <Button
        id={id}
        title={title}
        variant="ghost"
        onClick={() => handleExpand(isOpen)}
        logEvent={logEvent}
      >
        {description}
        <img
          src={arrow}
          alt={`Seta indicando para ${
            isOpen ? 'fechar' : 'abrir'
          } caixa de expansão`}
        />
      </Button>
    </S.Wrapper>
  ),
);
